import { createBrowserRouter } from 'react-router-dom';

import App from '@/App';
import { AccessError } from '@/pages/AccessError';
import { Admin } from '@/pages/Admin';
import { Home } from '@/pages/Home';
import { Login } from '@/pages/Login';
import { NotFound } from '@/pages/NotFound';
import { Preview } from '@/pages/Preview';

export const router = createBrowserRouter([
  // El login es una pantalla completa sin el header/footer del portal.
  { path: '/login', element: <Login /> },
  // Destino del callback cuando el login falla. Pública y fuera de <App />: quien
  // llega aquí no tiene sesión y el layout la pediría.
  { path: '/acceso-error', element: <AccessError /> },
  {
    path: '/',
    element: <App />,
    children: [
      { index: true, element: <Home /> },
      { path: 'admin', element: <Admin /> },
      { path: 'preview/:slug', element: <Preview /> },
      { path: '*', element: <NotFound /> },
    ],
  },
]);
